import React from 'react'
import {
  Card,
  /* CardHeader,  */ CardActionArea,
  CardContent,
  CardActions,
  Typography,
  Icon,
} from '@mui/material'
import { Link } from 'react-router-dom'

/*  */

export const CardWithIcon = (props) => {
  return (
    <Card variant='outlined' className={`card_with_icon ${props.customClass} ${!props.actions && 'pb-0'}`}>
      {props.to ? (
        <Link to={props.to} component={CardActionArea}>
          <CardContent style={{ display: 'flex' }}>
            {props.icon && <Icon className='icon'>{props.icon}</Icon>}
            <div className='content'>
              {props.title && (
                <Typography className='card-header-title' variant='h6'>
                  {props.title}
                </Typography>
              )}
              {props.children}
            </div>
          </CardContent>
        </Link>
      ) : (
        <CardContent style={{ display: 'flex' }}>
          {props.icon && <Icon className='icon'>{props.icon}</Icon>}
          <div className='content'>
            {props.title && (
              <Typography className='card-header-title' variant='h6'>
                {props.title}
              </Typography>
            )}
            {props.children}
          </div>
        </CardContent>
      )}

      {props.actions && <CardActions>{props.actions}</CardActions>}
    </Card>
  )
}


